export default class DataService {
  _data = {
    projectRepo: 'https://github.com/batuhanyslyrt0',
    react95Repo: 'https://github.com/React95/React95',
    items: [
      {
        id: 'about',
        name: 'About.txt',
        icon: 'user',
        content: {
          paragraphs: [
            "Selam, ben Batuhan 👋",
            "İstanbul merkezli; modern web teknolojileri, ölçeklenebilir altyapılar ve özel iş otomasyonları geliştiren bir Full-Stack Yazılım Geliştiricisiyim.",
            "Next.js, React, Node.js ve veritabanı mimarileriyle e-ticaret platformlarından özgün dijital projelere kadar uçtan uca yüksek performanslı sistemler tasarlıyorum.",
            "Nostaljik tasarımları ve modern mühendislik yaklaşımlarını bir araya getirmeyi seviyorum. Projelerimde hız, temiz mimari ve kullanıcı deneyimini ön planda tutuyorum."
          ],
        },
      },
      {
        id: 'photos',
        name: 'Photos.jpg',
        icon: 'progman_24',
      },
      {
        id: 'resume',
        name: 'Resume.txt',
        icon: 'notepad_2',
        content: {
          resumeLink: '',
          workExperience: [
            {
              jobTitle: 'Full-Stack Developer',
              company: 'Freelance',
              location: 'İstanbul',
              period: '2024 – Devam Ediyor',
              accomplishments: [
                'Berber Randevu & Yönetim Sistemi (berber.batudev.com) web ve WhatsApp entegrasyonlu randevu platformunun geliştirilmesi',
                'K-Design (k-design.com.tr) premium oto koltuk kılıfı e-ticaret platformunun full-stack geliştirilmesi',
                'Next.js, React, Node.js, TypeScript ile modern web uygulamaları geliştirme',
                'Responsive tasarım, SEO optimizasyonu ve performans iyileştirmeleri',
              ],
            },
          ],
        },
      },
      {
        id: 'projects',
        name: 'Projects.txt',
        icon: 'flying_through_space_100',
        content: {
          projects: [
            {
              title: 'Berber Randevu & Yönetim Sistemi',
              description:
                'Erkek kuaförleri ve salonlar için online ve WhatsApp entegrasyonlu anlık randevu alma, hizmet seçimi ve işletme yönetim platformu.',
              myRole: 'Full-Stack Developer',
              techStack: 'Next.js, React, Node.js, WhatsApp API, TailwindCSS',
              url: 'https://berber.batudev.com',
            },
            {
              title: 'K-Design E-Ticaret',
              description:
                'Premium oto koltuk kılıfı ve aksesuarları satan full-stack e-ticaret platformu. Araca özel kılıf seçimi, ürün filtreleme, sepet yönetimi ve ödeme sistemi.',
              myRole: 'Full-Stack Developer',
              techStack: 'Next.js, React, Node.js, TailwindCSS',
              url: 'https://k-design.com.tr',
            },
            {
              title: 'batudev.com (Win95 Portfolio)',
              description:
                'Windows 95 temalı kişisel portfolio sitesi. Evet, şu an baktığınız bu site!',
              techStack: 'React, React95, WebAmp',
              repo: 'https://github.com/batuhanyslyrt0',
            },
          ],
        },
      },
      {
        id: 'skills',
        name: 'Skills.txt',
        icon: 'progman_11',
        content: {
          hard: [
            { name: 'JavaScript', progress: 95 },
            { name: 'React', progress: 90 },
            { name: 'Next.js', progress: 90 },
            { name: 'Node.js', progress: 85 },
            { name: 'TypeScript', progress: 85 },
            { name: 'HTML/CSS', progress: 95 },
            { name: 'TailwindCSS', progress: 90 },
            { name: 'Git', progress: 85 },
            { name: 'MongoDB', progress: 75 },
            { name: 'SQL', progress: 70 },
            { name: 'Python', progress: 65 },
            { name: 'Docker', progress: 60 },
          ],
          soft: 'Öğrenmeye aç, problem çözmeye tutkulu bir geliştiriciyim. Takım çalışmasına yatkınım ve yeni teknolojileri keşfetmeyi seviyorum. Her bug bir macera, her deploy bir zafer! 🚀',
        },
      },
      {
        id: 'contact',
        name: 'Contact.txt',
        icon: 'inetcfg_2301',
        content: {
          emailText:
            'Bir proje fikrin mi var? Yoksa sadece merhaba mı demek istiyorsun? Her türlü yaz! ',
          email: 'batuhan.yesilyurt@outlook.com',
          socialText: 'Veya sosyal medyadan ulaş:',
          social: [
            {
              name: 'FaGithub',
              link: 'https://github.com/batuhanyslyrt0',
            },
            {
              name: 'FaLinkedin',
              link: 'https://tr.linkedin.com/in/batuhan-ye%C5%9Filyurt-597160284',
            },
            {
              name: 'FaInstagram',
              link: 'https://www.instagram.com/batuhanyslyrt0',
            },
          ],
        },
      },
      {
        id: 'admin',
        name: 'Admin.exe',
        icon: 'key_1',
        content: {},
      },
    ],
  };

  getItems() {
    return this._data.items.filter((x) => x.id !== 'admin').map(({ id, name, icon }) => ({ id, name, icon }));
  }

  getItem(id) {
    return this._data.items.find((x) => x.id === id);
  }

  getProjectInfo() {
    return {
      projectRepo: this._data.projectRepo,
      react95Repo: this._data.react95Repo,
    };
  }
}
